const URL = require('@tencent/search-url');

const spverMap = {
  num: 1,
  boolean: true,
};

function filterAdvData({ advList, key }) {
  if (!advList || !advList.length) {
    return null;
  }
  for (let i = 0, ilen = advList.length; i < ilen; i++) {
    const item = advList[i];
    if (item && item.posName.indexOf(key) > -1) {
      return advList[i];
    }
  }
}

function setCookie(name, value) {
  const expires = new Date(new Date().setHours(0, 0, 0, 0) + 86400 * 1000);
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};path=/;expires=${expires.toUTCString()}`;
}

function CookieGet(key) {
  let start;
  let end;
  const { cookie } = document;

  if (cookie && key) {
    start = cookie.indexOf(`${key}=`);
    if (start >= 0) {
      start = start + key.length + 1;
      end = cookie.indexOf(';', start);
      return cookie.substring(start, end === -1 ? cookie.length : end);
    }
  }

  return '';
}

function getCookieAbtest() {
  let abtest = CookieGet('ABTEST');
  if (abtest) {
    abtest = abtest.split('|');
    if (abtest.length === 3) {
      abtest = abtest[0]; // eslint-disable-line
      if ('01234'.includes(abtest)) {
        abtest = '0';
      }
      if ('56789'.includes(abtest)) {
        abtest = '1';
      }
      return abtest;
    }
  }
  return '';
}

function getSpver({ spver, returnType = 'num' }) {
  if (spver && +spver === 1) {
    return spverMap[returnType];
  }
  return null;
}

// 图片url转换
function imgUrlDeal(url) {
  if (!url || url.length < 1) {
    return url;
  }
  const randomNum = Math.ceil(Math.random() * 4);
  const sogouCdn = `//img0${randomNum}.sogoucdn.com/v2/thumb/resize/w/258/h/360/t/0/retype/ext/auto/q/75?appid=200839&url=`;
  return sogouCdn + url;
}

function checkHttpsUrl(url) {
  if (url.startsWith('http://') && url.indexOf('sogoucdn.com') > -1) {
    return url.replace(/^http:\/\//, '//');
  }
  return url;
}

// 获取参数发送日志使用
function getSsrUigsParams(options = {}) {
  let from = CookieGet('from');
  let ftype = CookieGet('ftype');
  const refer = document.referrer || document.referer || '';
  const { query = {} } = URL.parse(document.location.search) || {};
  const { vrid = '', kdExpId = '', expKey = '' } = query;

  if (!from) {
    if (refer) {
      const { host = '' } = URL.parse(refer);
      from = host;
      ftype = 'refer';
    }

    if (from.endsWith('sogou.com') && vrid) {
      from = vrid;
      ftype = 'vrid';
    }

    if (!from) {
      from = 'empty';
      ftype = 'default';
    }

    setCookie('from', from);
    setCookie('ftype', ftype);
  }
  // get SSR uigs_params
  const { innerWidth = 0, innerHeight = 0, qua = '', UIGS_PARA = {} } = window;
  const obj = {
    abtest: getCookieAbtest(),
    _v: '5',
    uigs_version: 'v1.2',
    screen_width: innerWidth,
    screen_height: innerHeight,
    from: CookieGet('from') || '',
    ftype: CookieGet('ftype') || '',
    uigs_refer: refer,
    uigs_uuid: new Date().getTime(),
    qua,
    vrid,
    kdExpId,
    expKey,
  };
  return Object.assign(obj, UIGS_PARA, options);
}

// 部分不能使用通用点击日志进行发送
function singlePageClParams(uigsCl) {
  const { UIGS_PARA = {}, __het = new Date().getTime() } = window;
  const clParams = {
    pbtype: 'cl',
    uigs_st: parseInt((new Date().getTime() - __het) / 1000, 10),
    uigs_cl: uigsCl,
  };
  return Object.assign({}, UIGS_PARA, clParams);
}

// 获取关闭参数
function getCloseParams() {
  const { UIGS_PARA = {}, __het = new Date().getTime() } = window;
  const st = parseInt((new Date().getTime() - __het) / 1000, 10);
  const clParams = {
    pbtype: 'cl',
    uigs_st: st,
    uigs_cl: `close=${st}`,
  };
  return Object.assign({}, UIGS_PARA, clParams);
}

// 获取到底部参数
function getBottomParams() {
  const { UIGS_PARA = {}, __het = new Date().getTime() } = window;
  const st = parseInt((new Date().getTime() - __het) / 1000, 10);
  const clParams = {
    pbtype: 'cl',
    uigs_st: st,
    uigs_cl: `tob=${st}`,
  };
  return Object.assign({}, UIGS_PARA, clParams);
}

function getScrollParams({ scrollParams }) {
  const { UIGS_PARA = {} } = window;
  delete UIGS_PARA.uigs_st;
  delete UIGS_PARA.uigs_cl;
  return Object.assign({}, UIGS_PARA, {
    scrollParams,
    pbtype: 'pv',
  });
}

const LOGO_CDN_PATH = '//dlweb.sogoucdn.com/video/wap/static/img/logo/';

module.exports = {
  filterAdvData,
  CookieGet,
  getCookieAbtest,
  getSpver,
  imgUrlDeal,
  checkHttpsUrl,
  getSsrUigsParams,
  singlePageClParams,
  getCloseParams,
  getBottomParams,
  getScrollParams,
  LOGO_CDN_PATH,
};
